import { useState, useEffect } from "react"

export type RisqueDetail = { present: boolean; libelle: string }

export type GeorisquesData = {
  risquesNaturels: Record<string, RisqueDetail>
  risquesTechnologiques: Record<string, RisqueDetail>
  url: string | null
}

const cache = new Map<string, GeorisquesData>()

export function useGeorisques(latitude: number | null, longitude: number | null) {
  const [data, setData] = useState<GeorisquesData | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (latitude == null || longitude == null) return

    const key = `${longitude},${latitude}`
    const cached = cache.get(key)
    if (cached) {
      setData(cached)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(null)

    const controller = new AbortController()
    fetch(
      `https://georisques.gouv.fr/api/v1/resultats_rapport_risque?latlon=${longitude}%2C${latitude}`,
      { signal: controller.signal },
    )
      .then((res) => res.json())
      .then((raw) => {
        if (cancelled) return
        const result: GeorisquesData = {
          risquesNaturels: raw?.risquesNaturels ?? {},
          risquesTechnologiques: raw?.risquesTechnologiques ?? {},
          url: raw?.url ?? null,
        }
        cache.set(key, result)
        setData(result)
        setLoading(false)
      })
      .catch((err) => {
        if (cancelled) return
        setError(err instanceof Error ? err.message : "Erreur de chargement")
        setLoading(false)
      })

    return () => {
      cancelled = true
      controller.abort()
    }
  }, [latitude, longitude])

  return { data, loading, error }
}
